import { useEffect } from 'react';

export const PlayerActions = () => {

  // Écouter les messages de la popup pour savoir quand elle se ferme
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const $crisp = (window as any).$crisp;

      if (event.data?.type === 'TRANSFER_COMPLETE') {
        console.log('✅ Transfert complété');
        // Fermer la modal Crisp
        if ($crisp && $crisp.closeModal) {
          $crisp.closeModal();
        }
        // Optionnel: rafraîchir ou notifier l'utilisateur
      } else if (event.data?.type === 'TRANSFER_CANCEL') {
        console.log('❌ Transfert annulé');
        // Fermer la modal Crisp
        if ($crisp && $crisp.closeModal) {
          $crisp.closeModal();
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleTransferClick = () => {
    const $crisp = (window as any).$crisp;

    if (!$crisp || !$crisp.showModal) {
      // MODE DEV ou SDK non disponible: Ouvrir dans une popup window classique
      console.log('🔧 Mode DEV: Ouverture popup window');
      const baseUrl = window.location.origin;
      const transferUrl = `${baseUrl}/transfer`;

      const popup = window.open(
        transferUrl,
        'transfer-popup',
        'width=500,height=700,left=100,top=100,resizable=yes,scrollbars=yes'
      );

      if (!popup) {
        alert('Veuillez autoriser les popups pour ce site');
      }
      return;
    }

    // MODE PRODUCTION: Utiliser le modal Crisp
    console.log('📱 Mode PROD: Ouverture modal Crisp');

    // Construire l'URL de la page de transfert
    const baseUrl = window.location.origin;
    const transferUrl = `${baseUrl}/transfer`;

    // Ouvrir en modal Crisp
    // Tailles disponibles : 'small', 'large'
    $crisp.showModal(transferUrl, 'large');
  };

  return (
    <div className="section">
      <button
        onClick={handleTransferClick}
        className="btn btn-primary w-full text-sm"
      >
        📤 Transférer la conversation
      </button>
    </div>
  );
};
